var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex",attrs:{"id":"age-chart"}},[_c('div',{staticClass:"age-title position-relative pr-1"},[_vm._v("\n      AGE\n    ")]),_vm._l((_vm.data),function(item,index){return _c('div',{key:item.age,staticClass:"age-chart-col d-flex justify-content-center align-items-center pt-1",style:({
        borderColor: _vm.colors[index],
        flex: item.size / _vm.totalSize,
      })},[_vm._v("\n      "+_vm._s(item.age)+"\n    ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }